import { render, staticRenderFns } from "./accreditor-report.vue?vue&type=template&id=c35c6550&scoped=true"
import script from "./accreditor-report.vue?vue&type=script&lang=js"
export * from "./accreditor-report.vue?vue&type=script&lang=js"
import style0 from "./accreditor-report.vue?vue&type=style&index=0&id=c35c6550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35c6550",
  null
  
)

export default component.exports